<template>
   <div>
       <el-tabs v-model="condition.txInnerStatus" @tab-click="handleClick">
           <el-tab-pane label="未审核" name="MANUAL"></el-tab-pane>
           <el-tab-pane label="已审核" name="ENSURED"></el-tab-pane>
           <el-tab-pane label="待定" name="RISK"></el-tab-pane>
           <el-tab-pane label="失败" name="FAIL"></el-tab-pane>
       </el-tabs>
       <el-form :inline="true">
           <el-form-item><el-input placeholder="输入币种" clearable v-model="condition.coinType"></el-input></el-form-item>
           <el-form-item><el-input placeholder="用户ID" clearable v-model="condition.userId"></el-input></el-form-item>
           <el-form-item><el-input placeholder="输入地址" clearable v-model="condition.address"></el-input></el-form-item>
           <el-form-item><el-input placeholder="输入memo" clearable v-model="condition.memo"></el-input></el-form-item>
           <el-form-item><el-input placeholder="输入hash" clearable v-model="condition.hash"></el-input></el-form-item>
           <el-form-item><el-button type="primary" @click="query(1)">查询</el-button></el-form-item>
       </el-form>

       <el-table :data="depositList">
           <el-table-column label="时间">
               <template slot-scope="scope">{{parseDateTime(scope.row.createdTime)}}</template>
           </el-table-column>
           <el-table-column label="账号" prop="userId"></el-table-column>
           <el-table-column label="币种" prop="txCoin"></el-table-column>
           <el-table-column label="充值数量" prop="txAmount"></el-table-column>
           <el-table-column label="充值地址" prop="txToAddress"></el-table-column>
           <el-table-column label="充值地址memo" prop="txToMemo"></el-table-column>
           <el-table-column label="hash" prop="txHash"></el-table-column>
           <el-table-column label="状态">
               <template slot-scope="scope">{{parseCodeToDesc(scope.row.txStatusInner)}}</template>
           </el-table-column>
           <el-table-column label="操作">
               <template slot-scope="scope">
                   <el-button type="text" @click="id = scope.row.id,show = true" v-if="scope.row.txStatusInner === 'MANUAL'">审核</el-button>
                   <el-button type="text" @click="setStatus(scope.row.id, 'ENSURED')" v-if="scope.row.txStatusInner === 'RISK'">通过</el-button>
                   <el-button type="text" @click="refuse(scope.row.id)" v-if="scope.row.txStatusInner === 'RISK'">不通过</el-button>
               </template>
           </el-table-column>
       </el-table>

       <el-pagination background layout="prev, pager, next" :total="depositTotal" :page-size="25" :current-page="condition.page" @current-change="query"></el-pagination>

       <el-dialog title="入账审核" :visible.sync="show">
           <el-form>
               <el-form-item>
                   <el-select v-model="InnerStatus" placeholder="请选择">
                       <el-option v-for="item in status" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                   </el-select>
               </el-form-item>
               <el-form-item>
                   <el-button type="info" @click="show = false">取消</el-button>
                   <el-button type="primary" @click="changeStatus()">确认</el-button>
               </el-form-item>
           </el-form>
       </el-dialog>

   </div>
</template>

<script>
    import api from './api';
    export default {
        name: "enterAccount",
        data(){
            return {
                condition:{
                    coinType: '',
                    txStatus: 10,
                    txInnerStatus: 'MANUAL',
                    address: '',
                    memo: '',
                    userId: '',
                    hash: '',
                    page: 1,
                },
                depositList:[],
                depositTotal: 0,
                show:false,
                status:[{code:'MANUAL',desc:'未审核'},{code:'ENSURED',desc:'已审核'},{code:'RISK',desc:'待定'},{code:'FAIL',desc:'失败'}],
                InnerStatus:'',
                id: ''
            }
        },
        created() {
            this.query(1);
        },
        methods: {
            handleClick(tab) {
                this.query(1);
            },
            query(val) {
                this.condition.page = val;
                api.queryEnterAccountList(this.condition).then(response =>{
                    this.depositList = response.data.list;
                    this.depositTotal = response.data.totalCount;
                })
            },
            parseCodeToDesc(code){
                if (code === 'MANUAL') {
                    return '未审核';
                }
                if (code === 'ENSURED') {
                    return '已审核';
                }
                if (code === 'RISK') {
                    return '待定';
                }
                if (code === 'FAIL') {
                    return '失败';
                }
            },
            parseDateTime(time){
                let now = new Date(time);
                let year=now.getFullYear();
                let month=now.getMonth()+1;
                let date=now.getDate();
                let hour=now.getHours();
                let minute=now.getMinutes();
                let second=now.getSeconds();
                return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second;
            },
            changeStatus(){
                api.checkEnterAccount({id: this.id,txInnerStatus: this.InnerStatus}).then(() =>{
                    this.$message.success('操作成功');
                    this.show = false;
                    this.query(1);
                })
            },
            setStatus(id, status){
                api.checkEnterAccount({id: id,txInnerStatus: status}).then(() =>{
                    this.$message.success('操作成功');
                    this.query(1);
                })
            },
            refuse(id){
                api.refuseEnterAccount({id: id}).then(() =>{
                    this.$message.success('操作成功');
                    this.query(1);
                })
            }
        }
    }
</script>

<style scoped>

</style>
